<template>
  <div>
    <!-- v-if="mounted" -->
    <medium-editor
      :class="{
        'form-field-error': vee ? vee.classes.failed : false,
        disabled: options.disableEditing,
      }"
      class="form-input-text medium-editor"
      :id="id"
      :text="value"
      :options="options"
      v-on:edit="processEditOperation"
      custom-tag="div"
    >
    </medium-editor>
  </div>
</template>

<script>
import vueMediumEditor from 'vue2-medium-editor'

export default {
  components: {
    'medium-editor': vueMediumEditor,
  },

  props: {
    id: {
      type: String,
      default: '',
    },

    value: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    vee: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    // https://github.com/yabwe/medium-editor/blob/master/OPTIONS.md
    options() {
      return {
        placeholder: {
          text: this.placeholder || '',
        },
        disableEditing: this.disabled || false,
        toolbar: {
          buttons: ['bold', 'italic', 'underline', 'anchor'],
        },
      }
    },
  },

  methods: {
    processEditOperation: function(operation) {
      this.$emit('input', this.clearHtml(operation.api.origElements.innerHTML))
    },
    clearHtml(htmlString) {
      const isEmpty = !htmlString.replace(/(<([^>]+)>)/gi, '').trim()
      return isEmpty ? '' : htmlString
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .medium-editor {
  min-height: 57px;

  &:hover:not(.disabled) {
    @apply cursor-text;
  }

  &:focus {
    outline: none !important;
  }

  &.disabled {
    opacity: 0.5;
  }
}
</style>
